import styled from 'styled-components';

import { colors, namedBreakpoints } from 'theme';

export const TileModalDesktopHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${namedBreakpoints.mdDown}) {
    display: none;
  }
`;

export const TileModalDesktopHeaderBlueLine = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 15px;
  background: ${colors.brandBlue};
`;

export const TileModalDesktopHeaderCloseContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 39px;
  margin-top: 20px;
`;
